import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalPlansService } from '../../store/modal-plans.service';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { CustomSnackbarComponent } from 'src/app/features/shared/components/custom-snackbar/custom-snackbar.component';

@Component({
  selector: 'app-modal-contact',
  templateUrl: './modal-contact.component.html',
  styleUrls: ['./modal-contact.component.scss']
})
export class ModalContactComponent implements OnInit, OnDestroy {

  requestConfirmed = false;
  loading = false;

  private subscriptions: Subscription[] = [];

  constructor(
    private modalPlansService: ModalPlansService,
    public snackBar: MatSnackBar,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  contactByWhatsapp() {
    const phoneNumber = '1234567890'; // TODO: Replace with the actual phone number
    const message = 'Hola, me gustaría contratar un plan.';
    const whatsappUrl = 'https://wa.me/5493512005467';
    window.open(whatsappUrl, '_blank');
  }

  confirmRequest() {
    this.loading = true;
    this.modalPlansService.customPlanNotice().subscribe(() => {
      this.requestConfirmed = true;
      this.loading = false;

    }, () => {
      this.snackBar.openFromComponent(CustomSnackbarComponent, {
        data: { message: this.translate.instant('shareCampaignPlanModal.oopsError'), type: 'error' },
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: 'error-snackbar',
      });
      this.loading = false;

    });
  }

}
